import { apiSlice } from "./api/apiSlice";

const cmpSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    addToCMP: builder.mutation({
      query: (data) => ({
        url: "cmp/add",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["CMP"],
    }),
    getMyCMP: builder.query({
      query: ({ month, year, project, clientId, phoneNumber, leadId }) => {
        const params = new URLSearchParams();
        if (month) params.append("month", month);
        if (year) params.append("year", year);
        if (project) params.append("project", project);
        if (clientId) params.append("clientId", clientId);
        if (phoneNumber) params.append("phoneNumber", phoneNumber);
        if (leadId) params.append("leadId", leadId);
        return { url: `cmp/my-cmp?${params.toString()}` };
      },
      providesTags: ["CMP"],
    }),
    getAllCMP: builder.query({
      query: ({ month, year, employeeId, project, clientId, phoneNumber, leadId }) => {
        const params = new URLSearchParams();
        if (month) params.append("month", month);
        if (year) params.append("year", year);
        if (employeeId) params.append("employeeId", employeeId);
        if (project) params.append("project", project);
        if (clientId) params.append("clientId", clientId);
        if (phoneNumber) params.append("phoneNumber", phoneNumber);
        if (leadId) params.append("leadId", leadId);
        return { url: `cmp/all?${params.toString()}` };
      },
      providesTags: ["CMP"],
    }),
    updateSBDMRemarks: builder.mutation({
      query: ({ cmpId, sbdmRemarks }) => ({
        url: `cmp/sbdm-remarks/${cmpId}`,
        method: "PUT",
        body: { sbdmRemarks },
      }),
      invalidatesTags: ["CMP"],
    }),
    updateCMPRemarks: builder.mutation({
      query: ({ cmpId, remarks }) => ({
        url: `cmp/remarks/${cmpId}`,
        method: "PUT",
        body: { remarks },
      }),
      invalidatesTags: ["CMP"],
    }),
    removeFromCMP: builder.mutation({
      query: (cmpId) => ({
        url: `cmp/remove/${cmpId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["CMP"],
    }),
    checkLeadInCMP: builder.query({
      query: (leadId) => ({
        url: `cmp/check/${leadId}`,
      }),
      providesTags: ["CMP"],
    }),
    getCMPClients: builder.query({
      query: () => ({ url: "cmp/clients" }),
      providesTags: ["CMP"],
    }),
  }),
});

export const {
  useAddToCMPMutation,
  useGetMyCMPQuery,
  useGetAllCMPQuery,
  useUpdateSBDMRemarksMutation,
  useUpdateCMPRemarksMutation,
  useRemoveFromCMPMutation,
  useLazyCheckLeadInCMPQuery,
  useGetCMPClientsQuery,
} = cmpSlice;
